module.exports = __webpack_public_path__ + "static/media/5.ff4ae47e.jpg";